(function (root, factory) {
  var api = factory();
  if (typeof module === "object" && module.exports) module.exports = api;
  if (root) root.BadgeBuzzBundleCollection = api;
})(typeof window !== "undefined" ? window : globalThis, function () {
  "use strict";

  var DISCOUNTS_ENDPOINT = "/apps/bb-portal/portal/v1/bundles/discounts";

  function discountBadges(root) {
    if (!root || typeof root.querySelectorAll !== "function") return [];
    return Array.prototype.slice.call(
      root.querySelectorAll("[data-bb-bundle-discount]"),
    );
  }

  function clearDiscounts(root) {
    discountBadges(root).forEach(function (badge) {
      badge.textContent = "";
      badge.hidden = true;
    });
  }

  function formatDiscountBasisPoints(value) {
    if (!Number.isInteger(value) || value <= 0 || value > 10000) return "";
    var whole = Math.floor(value / 100);
    var remainder = value % 100;
    var percentage = String(whole);
    if (remainder) {
      percentage += "." + String(remainder).padStart(2, "0").replace(/0$/, "");
    }
    return "Save " + percentage + "%";
  }

  function applyDiscounts(root, payload) {
    clearDiscounts(root);
    var settings =
      payload && Array.isArray(payload.bundles) ? payload.bundles : [];
    var byHandle = new Map();
    settings.forEach(function (setting) {
      if (!setting || typeof setting.handle !== "string") return;
      byHandle.set(setting.handle, setting.discount_basis_points);
    });

    discountBadges(root).forEach(function (badge) {
      var label = formatDiscountBasisPoints(
        byHandle.get(badge.getAttribute("data-bb-bundle-discount")),
      );
      if (!label) return;
      badge.textContent = label;
      badge.hidden = false;
    });
  }

  async function loadDiscounts(root, fetchImpl) {
    var request = fetchImpl || (typeof fetch === "function" ? fetch : null);
    if (!request) {
      clearDiscounts(root);
      return false;
    }
    try {
      var response = await request(DISCOUNTS_ENDPOINT, {
        credentials: "same-origin",
        headers: { Accept: "application/json" },
      });
      if (!response.ok) throw new Error("Bundle discounts unavailable");
      applyDiscounts(root, await response.json());
      return true;
    } catch (_error) {
      clearDiscounts(root);
      return false;
    }
  }

  function initialize(scope) {
    if (!scope || typeof scope.querySelectorAll !== "function") return;
    var roots = Array.prototype.slice.call(
      scope.querySelectorAll("[data-bb-bundle-collection]"),
    );
    if (
      typeof scope.matches === "function" &&
      scope.matches("[data-bb-bundle-collection]")
    ) {
      roots.unshift(scope);
    }
    roots.forEach(function (collection) {
      loadDiscounts(collection);
    });
  }

  if (typeof document !== "undefined") {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", function () {
        initialize(document);
      });
    } else {
      initialize(document);
    }
    document.addEventListener("shopify:section:load", function (event) {
      initialize(event.target);
    });
  }

  return {
    DISCOUNTS_ENDPOINT: DISCOUNTS_ENDPOINT,
    formatDiscountBasisPoints: formatDiscountBasisPoints,
    clearDiscounts: clearDiscounts,
    applyDiscounts: applyDiscounts,
    loadDiscounts: loadDiscounts,
    initialize: initialize,
  };
});
